import React from 'react';
import { Form, Message } from 'semantic-ui-react';

import './FooterEmailCapture.css';

class FooterEmailCapture extends React.PureComponent {
  render() {
    const { submitForm, updateFormFields, formFieldValues, isSuccess } = this.props;

    return (
      <Form size="tiny" onSubmit={submitForm} success={isSuccess}>
        <Form.Field>
          <label>Subscribe for updates</label>
          <Form.Input
            action={{
              primary: true,
              icon: 'send',
              type: 'submit',
            }}
            onChange={e => updateFormFields('email', e)}
            placeholder="Your Email"
            required
            type="email"
            value={formFieldValues.email}
          />
        </Form.Field>
        <Message success header="Subscribed!" />
      </Form>
    );
  }
}

export default FooterEmailCapture;
